import { useEffect, useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import MenuPainelAdmin from '../partils/AdminMenuPainel'

export default function AdminVendaRealizada() {
  const navigate = useNavigate()
  const TenancyColorUser = localStorage.getItem('localcolorusers')
  const token = localStorage.getItem('keyItemNameg')

  const config = {
    pageName: 'Venda de produtos',
    url: '/api/baixas_orcamento/',
    search: '/api/pivo_orcamento_produto/search/',
  }

  const [dataProdutos, setDataProdutos] = useState([])
  const [intervalinitialDate, setIntervalinitialDate] = useState()
  const [intervalfinalDate, setIntervalfinalDate] = useState()

  useEffect(() => { rec() }, [])

  const headers = { 'Content-Type': 'application/json', token }

  const rec = () => {
    axios.get(config.url, { headers }).then(resp => { })
  }

  const listarprodutos = () => {
    axios.get(`/api/dashboard/pivoorcaprod/contprodutosvendidos/${intervalinitialDate}/${intervalfinalDate}`)
      .then(resp => {
        setDataProdutos(resp.data)
        console.log(resp.data)
      })
      
  }

  const totais = dataProdutos.reduce((acc, item) => {
    const qtd = Number(item.quantidade)
    const custo = Number(item.produto_servico.custo)
    const preco = Number(item.produto_servico.preco)
    const precoFinal = Number(item.preco)

    acc.quantidade += qtd
    acc.lucro += (preco - custo) * qtd
    acc.vendas += precoFinal * qtd
    return acc
  }, { quantidade: 0, lucro: 0, vendas: 0 })

  const finalprodutos = dataProdutos.map(item =>
    <div className="w95 row between linha" key={item.id_pivo_orcamento_produto}>
      <label className="fs09em w10 cell-none">
        {new Date(item.createdAt)
          .toLocaleDateString("pt-BR")
          .slice(0, 6) + new Date(item.createdAt).getFullYear().toString().slice(2)}
      </label>
      <label className="fs09em w10 cell-tamanho10">{item.cliente.nome.slice(0,9)}</label>{/* Cliente fornecedor */}
      <label className="fs09em w8 cell-tamanho20">{item.orcamento.cliente.nome.slice(0,9)}</label>
      <label className="fs09em w5">{item.quantidade}</label>
      <label className="fs09em w20">{item.produto_servico.descricao}</label>
      <label className="fs09em w8 cell-none">{item.produto_servico.custo}</label>
      <label className="fs09em w8 cell-none">{(item.produto_servico.preco - item.produto_servico.custo).toFixed(2)}</label>
      <label className="fs09em w8 cell-none">{(item.quantidade * (item.produto_servico.preco - item.produto_servico.custo)).toFixed(2)}</label>
      <label className="fs09em w10" style={{
        background: item.orcamento.status === 1 ? "#68A652" :
                    item.orcamento.status === 2 ? "#FFEC87" :
                    item.orcamento.status === 3 ? "#B1FF95" :
                    item.orcamento.status === 4 ? "#FFA487" : "transparent",
        fontSize: '0.8em', textAlign: 'center'
      }}>
        {item.orcamento.status === 1 ? "Em Serv." :
         item.orcamento.status === 2 ? "Pg Pend" :
         item.orcamento.status === 3 ? "Pago" :
         item.orcamento.status === 4 ? "Cancelado" : ""}
      </label>
      <label className="fs09em w10 cell-tamanho20 fim">{(item.preco * item.quantidade).toFixed(2)}</label>
    </div>
  )

  const totalLinha =
    <div className="w95 row between linha pc10l5" style={{ fontWeight: 'bold', borderTop: '2px solid #000', marginTop: 10 }}>
      <label className="fs1em w15">Totais:</label>
      <label className="fs1em w5">{totais.quantidade}</label>
      <label className="fs09em w30 cell-none">--</label>
      <label className="fs09em w10  cell-none">--</label>
      <label className="fs09em w10  cell-none">--</label>
      <label className="fs1em w10 cell-tamanho20">R$: {totais.lucro.toFixed(2)}</label>
      <label className="fs09em w10  cell-none">--</label>
      <label className="fs1em w10 cell-tamanho20">R$: {totais.vendas.toFixed(2)}</label>
    </div>

const nomesUnicos = [...new Set(dataProdutos.map(item => item.cliente.nome))];

const handleChange = (e) => {
  const nomeSelecionado = e.target.value;
  const filtrados = dataProdutos.filter(produto => produto.cliente.nome === nomeSelecionado);
  setDataProdutos(filtrados); // ou setDataFiltrada(filtrados)
};

  return (
    <section className='h100 row between b31'>
      <MenuPainelAdmin />
      <div className="h100 w80 cell-tamanho row center celular">
        <div className="w100 row between cell-tamanho celular">
          <div className="h100 w100 cont-circ3 column cell-paddingcb10">
            <h5 className='fs2em fb w90'>{config.pageName}</h5>
            <label className='w90 c2'>Dinheiro recebido no dia...</label>

            <div className='w90 row start'>
              {['/adminvendarealizada', '/admincaixa', '/adminvendaprodutoservico'].map((path, i) => (
                <div key={i} className='pc10l5 borda1 m10' onClick={() => navigate(path)} style={path === '/adminvendaprodutoservico' ? { backgroundColor: TenancyColorUser } : {}}>
                  <span className="fb w79 pc10l5 no-hover pp fs08em">
                    {['Faturamento', 'Caixa', 'Vendas'][i]}
                  </span>
                </div>
              ))}
            </div>

            <div className='w90 h20 column'>
              <label className='w100 ma5 fs1p3em'>Produtos Vendidos</label>
              <div className="w100 b2 c3 b2 flex row center ma10b0">
                <label className="w95 ma5">Selecione o intervalo de datas</label>
                <div className="w95 row between">
                  <div className="w33">
                    <label className="fs08em">Início</label>
                    <input type="date" onChange={e => setIntervalinitialDate(e.target.value)} />
                  </div>
                  <div className="w33">
                    <label className="fs08em">Fim</label>
                    <input type="date" onChange={e => setIntervalfinalDate(e.target.value)} />
                  </div>
                  <div className="w25">
                    <label>Ação</label>
                    <button
                      className="w95"
                      style={{ backgroundColor: intervalfinalDate ? TenancyColorUser : '#c1c1c1', borderRadius: '8px' }}
                      onClick={listarprodutos}
                      disabled={!intervalfinalDate}
                    >
                      Ir
                    </button>
                  </div>
                  {intervalfinalDate&&
                  <div className="fs08em ma5 row between w100">
                    <label className='w100'>Filtro</label>
                    <div className='w30'>
                     <select onChange={handleChange}>
                        <option value="">-- Selecione um fornecedor --</option>
                        {nomesUnicos.map((nome, index) => (
                          <option key={index} value={nome}>
                            {nome}
                          </option>
                        ))}
                    </select>
                    </div>
                    <div className='w10 b16 pc10l5 pp' onClick={() => {
                      const filtrados = dataProdutos.filter(produto => produto.orcamento.status===3);
                      setDataProdutos(filtrados); // ou setDataFiltrada(filtrados)
                    }}>
                      Pagos
                    </div>
                    <div className='w10 b16 pc10l5 pp' onClick={() => {
                      const filtrados = dataProdutos.filter(produto => produto.orcamento.status===2);
                      setDataProdutos(filtrados); // ou setDataFiltrada(filtrados)
                    }}>
                      Pg.Pend
                    </div>
                    <div className='w10 b16 pc10l5 pp' onClick={() => {
                      const filtrados = dataProdutos.filter(produto => produto.orcamento.status===1);
                      setDataProdutos(filtrados); // ou setDataFiltrada(filtrados)
                    }}>
                      Em serviço
                    </div>
                    <div className='w10 b16 pc10l5 pp' onClick={() => {
                      const filtrados = dataProdutos.filter(produto => produto.orcamento.status===4);
                      setDataProdutos(filtrados); // ou setDataFiltrada(filtrados)
                    }}>
                      Cancelado
                    </div>
                    
                    {`De: ${intervalinitialDate} até ${intervalfinalDate}`}
                  </div>
                  }
                </div>
                <div className='w100 column center'>
                  <div className="w95 row between linha b15 pc10l5">
                    <label className="fs09em w10">Data</label>
                    <label className="fs09em w10">Forne</label>{/* Cliente fornecedor */}
                    <label className="fs09em w8">Cliente</label>
                    <label className="fs09em w5">Qnt</label>
                    <label className="fs09em w20">Desc</label>
                    <label className="fs09em w8">C.Unt</label>
                    <label className="fs09em w8">L.Unt</label>
                    <label className="fs09em w8">L.Tot</label>
                    <label className="fs09em w10">Status</label>
                    <label className="fs09em w10">Valor</label>
                  </div>
                  {finalprodutos}
                  {dataProdutos.length > 0 && totalLinha}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}





